export function noSpecialChars(value) {
  return /^[a-zA-Z0-9]/.test(value);
}

export function onlyDigits(value) {
  return /\d/g.test(value);
}
